import * as Sentry from "@sentry/browser";
import * as ReactSentry from "@sentry/react";
import type { RouterHistory } from "@sentry/react/build/types/reactrouter";
import { Route } from "react-router-dom";
import { isDefined } from "../utils/helpers";

if (!window.APP_SETTINGS) {
  window.APP_SETTINGS = Object.assign({
      user: {
          id: 9999,
          username: "test",
          firstName: "test",
          lastName: "test",
          initials: "test",
          email: "test@st.com",
          allow_newsletters: "false",
      },
      debug: false,
      hostname: location.origin,
      version: {
          "release": "1.19.0.dev0",
          "label-studio-os-package": {
              "version": "1.19.0.dev0",
              "short_version": "1.19",
              "latest_version_from_pypi": "1.20.0",
              "latest_version_upload_time": "2025-07-01T07:29:54",
              "current_version_is_outdated": true
          },
          "label-studio-os-backend": {
              "message": "fix: remove hard coded part",
              "commit": "26e892d0c08607675daac6cff2fd17df8b525620",
              "date": "2025/09/15 11:30:51",
              "branch": "chore/chore-update-ci-yaml",
              "version": "nightly+101.g26e892d0c.dirty"
          },
          "label-studio-converter": {
              "version": "1.0.12"
          },
          "edition": "Community",
          "lsf": {
              "commit": "26e892"
          },
          "dm2": {
              "commit": "26e892"
          },
          "backend": {
              "commit": "26e892"
          }
      },
      sentry_dsn: "https://5f51920ff82a4675a495870244869c6b@o227124.ingest.sentry.io/5838868",
      sentry_rate: "0.01",
      sentry_environment: "opensource",
      editor_keymap: JSON.parse(null),
      feature_flags: {
          "feat_all_optic_71_dashboard_multiple_labeling_group_support_v1_01092023_short": true,
          "feat_front_dev_1752_notification_links_in_label_and_review_streams": false,
          "feat_front_dev_3260_alternative_shortcuts_for_video_naviagtion": false,
          "feat_front_dev_399_lock_interface_when_trial_expired_short": false,
          "feat_optic_1098_annotation_history_lead_time_charts": false,
          "ff_back_2004_async_review_24032022_short": false,
          "ff_back_2884_comments_notifications_02092022_short": true,
          "ff_back_DEV_1711_review_queue_140222_short": true,
          "ff_back_DEV_3374_review_query_160922_short": false,
          "ff_back_dev_1417_start_training_mlbackend_webhooks_250122_long": true,
          "ff_back_dev_1948_reviewed_status_16052022_short": false,
          "ff_back_dev_2362_project_credentials_060722_short": false,
          "ff_back_dev_2762_textarea_weights_30062022_short": true,
          "ff_back_dev_4664_remove_storage_file_on_export_delete_29032023_short": false,
          "ff_back_experimental_features": false,
          "ff_fix_back_dev_3342_storage_scan_with_invalid_annotations": true,
          "ff_front_1170_outliner_030222_short": true,
          "ff_front_DEV_1713_audio_ui_150222_short": false,
          "ff_front_dev_1442_unselect_shape_on_click_outside_080622_short": false,
          "ff_front_dev_1480_created_on_in_review_180122_short": true,
          "ff_front_dev_1536_taxonomy_user_labels_150222_long": true,
          "ff_front_dev_1658_notification_center_170222_short": false,
          "ff_front_dev_1682_model_version_dropdown_070622_short": false,
          "ff_front_dev_2186_comments_for_update": false,
          "ff_front_dev_2669_paragraph_author_filter_210622_short": true,
          "ff_front_dev_2671_anchor_rotate_bbox_010722_short": false,
          "ff_front_dev_2715_audio_3_280722_short": true,
          "ff_front_optic_1494_saved_templates_to_custom_templates": true,
          "ff_front_optic_1610_ask_ai_questions": false,
          "fflag-feat-dev-2887-comments-ui-editor-short": false,
          "fflag-feat-dev-3034-comments-with-drafts-short": false,
          "fflag-feat-front-dev-2866-free-trial-invite-short": false,
          "fflag-feat-front-dev-3051-trial-experience": false,
          "fflag__feature_develop__prompts__dia_1829_jwt_token_auth": true,
          "fflag__feature_develop__prompts__dia_1868_azure_ai_foundry": true,
          "fflag_all_feat_dia_1777_ls_homepage_short": true,
          "fflag_feat_all_dia_1576_prompts_easy_breezy_onboarding_long": false,
          "fflag_feat_all_dia_1576_prompts_easy_breezy_onboarding_short_async_presets_ks": false,
          "fflag_feat_all_dia_1700_pinned_organization_sidebar": false,
          "fflag_feat_all_dia_2067_tasks_table_component": false,
          "fflag_feat_all_dia_835_prompter_workflow_long": false,
          "fflag_feat_all_leap_1081_reviewer_flow_updates": true,
          "fflag_feat_all_leap_1181_bulk_annotation_short": true,
          "fflag_feat_all_leap_1429_flexible_reject_mode_250924_short": true,
          "fflag_feat_all_leap_1430_per_field_comments_100924_short": true,
          "fflag_feat_all_leap_1534_custom_task_lock_timeout_short": false,
          "fflag_feat_all_leap_1682_plugins_v0": true,
          "fflag_feat_all_leap_1732_pausing_an_annotator_short": true,
          "fflag_feat_all_leap_1821_annotation_limit_short": true,
          "fflag_feat_all_leap_1825_annotator_evaluation_short": true,
          "fflag_feat_all_leap_2042_average_agreement_score_popover": false,
          "fflag_feat_all_leap_883_custom_script_270524_short": true,
          "fflag_feat_all_lops_315_temp_datasets_limitations_short": false,
          "fflag_feat_all_lops_e_3_datasets_short": false,
          "fflag_feat_all_lsdv_4915_async_task_import_13042023_short": false,
          "fflag_feat_all_lsdv_e_294_llm_annotations_180723_long": true,
          "fflag_feat_all_lsdv_e_295_project_level_roles_via_saml_scim_ldap_short": true,
          "fflag_feat_all_optic_1178_reduce_memory_leak_short": true,
          "fflag_feat_all_optic_1181_membership_performance": false,
          "fflag_feat_all_optic_1354_sum_annotation_region_count_short": false,
          "fflag_feat_all_optic_1811_automax_project_setup_streaming": true,
          "fflag_feat_all_optic_520_annotator_report_short": true,
          "fflag_feat_all_optic_991_dashboard_v2_short": true,
          "fflag_feat_back_dev_3756_queue_enrollment_min_short": false,
          "fflag_feat_back_lsdv_3958_server_side_encryption_for_target_storage_short": false,
          "fflag_feat_back_lsdv_4932_enable_memory_profiler": false,
          "fflag_feat_back_lsdv_5307_import_reviews_drafts_29062023_short": false,
          "fflag_feat_back_optic_1157_set_ground_truths_action": true,
          "fflag_feat_back_optic_1579_force_memory_profiler": false,
          "fflag_feat_back_optic_428_scim_multi_mapping": false,
          "fflag_feat_backend_optic_427_org_member_role_throttling_short": false,
          "fflag_feat_dev_2755_regions_list_grouped_by_labels_with_ordered_collapse_short": false,
          "fflag_feat_dia_1528_gemini_models_support_vertex_ai_support_short": true,
          "fflag_feat_dia_1661_improve_prompts_discovery_and_conversion": false,
          "fflag_feat_dia_1697_product_tour_short": false,
          "fflag_feat_dia_1920_project_creation_sample_data_short": false,
          "fflag_feat_dia_1925_view_sample_raw_json_short": false,
          "fflag_feat_dia_2092_multitasks_per_storage_link": false,
          "fflag_feat_front_dev-2536_comment_notifications_short": false,
          "fflag_feat_front_dev_3051_trial_experience_short": false,
          "fflag_feat_front_dev_3077_repeater_tag_loading_performance_short": true,
          "fflag_feat_front_dev_3873_labeling_ui_improvements_short": true,
          "fflag_feat_front_dia_1747_projects_list_banner": false,
          "fflag_feat_front_leap_1173_disable_postpone_skip_short": false,
          "fflag_feat_front_leap_1198_unsaved_changes_180724": true,
          "fflag_feat_front_leap_1424_grid_preview_short": true,
          "fflag_feat_front_leap_1973_adjustable_spans_090425_short": true,
          "fflag_feat_front_leap_2036_annotations_summary": false,
          "fflag_feat_front_leap_482_self_serve_short": false,
          "fflag_feat_front_lops_134_find_similarity_29082023_short": false,
          "fflag_feat_front_lops_86_datasets_storage_edit_short": false,
          "fflag_feat_front_lsdv_4583_6_images_preloading_short": true,
          "fflag_feat_front_lsdv_4583_multi_image_segmentation_short": true,
          "fflag_feat_front_lsdv_5451_async_taxonomy_110823_short": true,
          "fflag_feat_front_lsdv_5452_taxonomy_labeling_110823_short": true,
          "fflag_feat_front_lsdv_e_278_contextual_scrolling_short": true,
          "fflag_feat_front_lsdv_e_297_increase_oss_to_enterprise_adoption_short": true,
          "fflag_feat_front_optic_1217_theme_toggle_short": true,
          "fflag_feat_front_optic_1351_use_new_projects_counts_api_short": true,
          "fflag_feat_front_optic_1417_improve_project_list_cache_short": false,
          "fflag_feat_front_optic_1479_improve_image_tag_memory_usage_short": true,
          "fflag_feat_front_optic_1553_url_based_region_visibility_short": true,
          "fflag_feat_front_optic_1746_improve_global_error_messages_short": true,
          "fflag_feat_front_optic_1856_ask_ai_support_ticket_creation_short": false,
          "fflag_feat_front_optic_66_lazy_chart_evaluation_19092023_short": false,
          "fflag_feat_front_optic_767_annotator_project_multiselect_short": true,
          "fflag_feat_front_optic_optic_1442_hubspot_talk_to_sales_modal_short": false,
          "fflag_feat_front_prod_281_project_list_search_19072023_short": true,
          "fflag_feat_optic_1025_zendesk_widget_integration": false,
          "fflag_feat_optic_161_project_settings_for_low_agreement_threshold_score_short": false,
          "fflag_feat_optic_2123_audio_spectrograms": false,
          "fflag_feat_optic_2125_timeseries_sync": false,
          "fflag_feat_optic_378_limit_projects_per_page_to_ten_short": true,
          "fflag_feat_optic_650_target_storage_task_format_long": false,
          "fflag_feat_optic_67_drag_and_drop_charts": true,
          "fflag_feature_all_optic_1421_cold_start_v2": false,
          "fflag_feature_all_optic_1541_performance_score_on_latest_review_short": false,
          "fflag_fix_all_leap_877_annotator_membership_api_03042024_short": true,
          "fflag_fix_all_lsdv_4711_cors_errors_accessing_task_data_short": true,
          "fflag_fix_all_lsdv_4813_async_export_conversion_22032023_short": false,
          "fflag_fix_all_lsdv_4896_dm_actions_to_reviewers_20230403_short": false,
          "fflag_fix_all_lsdv_4971_async_reimport_09052023_short": true,
          "fflag_fix_all_optic_18_dashboard_label_distribution_chart_async_22082023_short": false,
          "fflag_fix_all_optic_79_task_count_is_wrong_short": false,
          "fflag_fix_back_dev_3668_review_stream_optimizaion_short": false,
          "fflag_fix_back_dev_4174_overlap_issue_experiments_10012023_short": false,
          "fflag_fix_back_dev_4185_next_task_additional_logging_long": false,
          "fflag_fix_back_leap_1818_set_convert_background_failure_logging_02062025_short": false,
          "fflag_fix_back_leap_612_explore_review_09042024_short": true,
          "fflag_fix_back_lsdv_4523_show_overlap_first_order_27022023_short": false,
          "fflag_fix_back_lsdv_4604_excess_sql_queries_in_api_short": true,
          "fflag_fix_back_lsdv_4929_limit_exports_10042023_short": true,
          "fflag_fix_back_lsdv_5425_1_enable_permissions_restrictions_for_annotators_long": false,
          "fflag_fix_back_optic_1380_dashboard_task_chart_grouped_by_completed_at_reviewed_at_short": true,
          "fflag_fix_back_optic_1407_optimize_tasks_api_pagination_counts": true,
          "fflag_fix_font_lsdv_3009_draft_saving_stuck_130223_short": false,
          "fflag_fix_front_dev_1284_auto_detect_undo_281022_short": true,
          "fflag_fix_front_dev_2918_labeling_filtered_paragraphs_250822_short": false,
          "fflag_fix_front_dev_3377_image_regions_shift_on_resize_280922_short": true,
          "fflag_fix_front_dev_3391_interactive_view_all": false,
          "fflag_fix_front_dev_3793_relative_coords_short": true,
          "fflag_fix_front_leap_218_improve_performance_of_taxonomy_search_short": true,
          "fflag_fix_front_leap_32_zoom_perf_190923_short": true,
          "fflag_fix_front_leap_443_select_annotation_once": false,
          "fflag_fix_front_lsdv_4600_lead_time_27072023_short": false,
          "fflag_fix_front_lsdv_4620_memory_leaks_100723_short": false,
          "fflag_fix_front_lsdv_4930_selection_tool_fixes_240423_short": true,
          "fflag_fix_front_lsdv_4998_missed_dynamic_children_030523_short": true,
          "fflag_fix_front_optic_1418_cache_members_manager_apis_short": false,
          "fflag_fix_front_optic_1608_improve_video_frame_seek_precision_short": true,
          "fflag_fix_leap_2052_detect_empty_filters_at_next_task_endpoint_short": true,
          "fflag_fix_leap_246_multi_object_hotkeys_160124_short": true,
          "fflag_fix_leap_466_text_sanitization": true,
          "fflag_fix_optic_1259_lse_projects_read_apis_use_replica_short": true,
          "fflag_fix_optic_214_extra_blank_dashboard_charts_short": true,
          "fflag_fix_optic_391_tasks_outside_low_agreement_project_counts_short": true,
          "fflag_front_dia_1150_ddisco_sneak_preview": false,
          "fflag_optic_all_optic_1938_storage_proxy": true,
          "fix_backend_dev_3134_exclude_deactivated_users": false,
          "$flagsState": {
              "feat_all_optic_71_dashboard_multiple_labeling_group_support_v1_01092023_short": {
                  "version": 4,
                  "variation": 1
              },
              "feat_front_dev_1752_notification_links_in_label_and_review_streams": {
                  "version": 2,
                  "variation": 1
              },
              "feat_front_dev_3260_alternative_shortcuts_for_video_naviagtion": {
                  "version": 2,
                  "variation": 1
              },
              "feat_front_dev_399_lock_interface_when_trial_expired_short": {
                  "version": 2,
                  "variation": 1
              },
              "feat_optic_1098_annotation_history_lead_time_charts": {
                  "version": 3,
                  "variation": 1
              },
              "ff_back_2004_async_review_24032022_short": {
                  "version": 4,
                  "variation": 1
              },
              "ff_back_2884_comments_notifications_02092022_short": {
                  "version": 4,
                  "variation": 1
              },
              "ff_back_DEV_1711_review_queue_140222_short": {
                  "version": 5,
                  "variation": 1
              },
              "ff_back_DEV_3374_review_query_160922_short": {
                  "version": 3,
                  "variation": 1
              },
              "ff_back_dev_1417_start_training_mlbackend_webhooks_250122_long": {
                  "version": 5,
                  "variation": 0
              },
              "ff_back_dev_1948_reviewed_status_16052022_short": {
                  "version": 5,
                  "variation": 1
              },
              "ff_back_dev_2362_project_credentials_060722_short": {
                  "version": 3,
                  "variation": 1
              },
              "ff_back_dev_2762_textarea_weights_30062022_short": {
                  "version": 5,
                  "variation": 0
              },
              "ff_back_dev_4664_remove_storage_file_on_export_delete_29032023_short": {
                  "version": 2,
                  "variation": 1
              },
              "ff_back_experimental_features": {
                  "version": 3,
                  "variation": 1
              },
              "ff_fix_back_dev_3342_storage_scan_with_invalid_annotations": {
                  "version": 4,
                  "variation": 0
              },
              "ff_front_1170_outliner_030222_short": {
                  "version": 5,
                  "variation": 0
              },
              "ff_front_DEV_1713_audio_ui_150222_short": {
                  "version": 2,
                  "variation": 1
              },
              "ff_front_dev_1442_unselect_shape_on_click_outside_080622_short": {
                  "version": 7,
                  "variation": 1
              },
              "ff_front_dev_1480_created_on_in_review_180122_short": {
                  "version": 6,
                  "variation": 1
              },
              "ff_front_dev_1536_taxonomy_user_labels_150222_long": {
                  "version": 6,
                  "variation": 0
              },
              "ff_front_dev_1658_notification_center_170222_short": {
                  "version": 3,
                  "variation": 1
              },
              "ff_front_dev_1682_model_version_dropdown_070622_short": {
                  "version": 9,
                  "variation": 1
              },
              "ff_front_dev_2186_comments_for_update": {
                  "version": 7,
                  "variation": 1
              },
              "ff_front_dev_2669_paragraph_author_filter_210622_short": {
                  "version": 5,
                  "variation": 0
              },
              "ff_front_dev_2671_anchor_rotate_bbox_010722_short": {
                  "version": 2,
                  "variation": 1
              },
              "ff_front_dev_2715_audio_3_280722_short": {
                  "version": 4,
                  "variation": 0
              },
              "ff_front_optic_1494_saved_templates_to_custom_templates": {
                  "version": 4,
                  "variation": 0
              },
              "ff_front_optic_1610_ask_ai_questions": {
                  "version": 3,
                  "variation": 1
              },
              "fflag-feat-dev-2887-comments-ui-editor-short": {
                  "version": 9,
                  "variation": 1
              },
              "fflag-feat-dev-3034-comments-with-drafts-short": {
                  "version": 6,
                  "variation": 1
              },
              "fflag-feat-front-dev-2866-free-trial-invite-short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag-feat-front-dev-3051-trial-experience": {
                  "version": 3,
                  "variation": 1
              },
              "fflag__feature_develop__prompts__dia_1829_jwt_token_auth": {
                  "version": 7,
                  "variation": 0
              },
              "fflag__feature_develop__prompts__dia_1868_azure_ai_foundry": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_all_feat_dia_1777_ls_homepage_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_feat_all_dia_1576_prompts_easy_breezy_onboarding_long": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_dia_1576_prompts_easy_breezy_onboarding_short_async_presets_ks": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_dia_1700_pinned_organization_sidebar": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_dia_2067_tasks_table_component": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_dia_835_prompter_workflow_long": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_feat_all_leap_1081_reviewer_flow_updates": {
                  "version": 8,
                  "variation": 0
              },
              "fflag_feat_all_leap_1181_bulk_annotation_short": {
                  "version": 6,
                  "variation": 0
              },
              "fflag_feat_all_leap_1429_flexible_reject_mode_250924_short": {
                  "version": 4,
                  "variation": 0
              },
              "fflag_feat_all_leap_1430_per_field_comments_100924_short": {
                  "version": 7,
                  "variation": 0
              },
              "fflag_feat_all_leap_1534_custom_task_lock_timeout_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_all_leap_1682_plugins_v0": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_all_leap_1732_pausing_an_annotator_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_all_leap_1821_annotation_limit_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_all_leap_1825_annotator_evaluation_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_all_leap_2042_average_agreement_score_popover": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_leap_883_custom_script_270524_short": {
                  "version": 7,
                  "variation": 0
              },
              "fflag_feat_all_lops_315_temp_datasets_limitations_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_all_lops_e_3_datasets_short": {
                  "version": 6,
                  "variation": 1
              },
              "fflag_feat_all_lsdv_4915_async_task_import_13042023_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_lsdv_e_294_llm_annotations_180723_long": {
                  "version": 8,
                  "variation": 0
              },
              "fflag_feat_all_lsdv_e_295_project_level_roles_via_saml_scim_ldap_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_optic_1178_reduce_memory_leak_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_all_optic_1181_membership_performance": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_optic_1354_sum_annotation_region_count_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_all_optic_1811_automax_project_setup_streaming": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_all_optic_520_annotator_report_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_all_optic_991_dashboard_v2_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_back_dev_3756_queue_enrollment_min_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_back_lsdv_3958_server_side_encryption_for_target_storage_short": {
                  "version": 5,
                  "variation": 1
              },
              "fflag_feat_back_lsdv_4932_enable_memory_profiler": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_feat_back_lsdv_5307_import_reviews_drafts_29062023_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_back_optic_1157_set_ground_truths_action": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_back_optic_1579_force_memory_profiler": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_back_optic_428_scim_multi_mapping": {
                  "version": 8,
                  "variation": 1
              },
              "fflag_feat_backend_optic_427_org_member_role_throttling_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_dev_2755_regions_list_grouped_by_labels_with_ordered_collapse_short": {
                  "version": 5,
                  "variation": 1
              },
              "fflag_feat_dia_1528_gemini_models_support_vertex_ai_support_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_dia_1661_improve_prompts_discovery_and_conversion": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_dia_1697_product_tour_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_dia_1920_project_creation_sample_data_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_dia_1925_view_sample_raw_json_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_dia_2092_multitasks_per_storage_link": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_front_dev-2536_comment_notifications_short": {
                  "version": 5,
                  "variation": 1
              },
              "fflag_feat_front_dev_3051_trial_experience_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_feat_front_dev_3077_repeater_tag_loading_performance_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_front_dev_3873_labeling_ui_improvements_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_feat_front_dia_1747_projects_list_banner": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_front_leap_1173_disable_postpone_skip_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_feat_front_leap_1198_unsaved_changes_180724": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_feat_front_leap_1424_grid_preview_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_front_leap_1973_adjustable_spans_090425_short": {
                  "version": 4,
                  "variation": 0
              },
              "fflag_feat_front_leap_2036_annotations_summary": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_front_leap_482_self_serve_short": {
                  "version": 6,
                  "variation": 1
              },
              "fflag_feat_front_lops_134_find_similarity_29082023_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_feat_front_lops_86_datasets_storage_edit_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_front_lsdv_4583_6_images_preloading_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_feat_front_lsdv_4583_multi_image_segmentation_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_feat_front_lsdv_5451_async_taxonomy_110823_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_feat_front_lsdv_5452_taxonomy_labeling_110823_short": {
                  "version": 4,
                  "variation": 0
              },
              "fflag_feat_front_lsdv_e_278_contextual_scrolling_short": {
                  "version": 6,
                  "variation": 0
              },
              "fflag_feat_front_lsdv_e_297_increase_oss_to_enterprise_adoption_short": {
                  "version": 16,
                  "variation": 0
              },
              "fflag_feat_front_optic_1217_theme_toggle_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_front_optic_1351_use_new_projects_counts_api_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_front_optic_1417_improve_project_list_cache_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_feat_front_optic_1479_improve_image_tag_memory_usage_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_front_optic_1553_url_based_region_visibility_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_front_optic_1746_improve_global_error_messages_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_feat_front_optic_1856_ask_ai_support_ticket_creation_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_front_optic_66_lazy_chart_evaluation_19092023_short": {
                  "version": 4,
                  "variation": 0
              },
              "fflag_feat_front_optic_767_annotator_project_multiselect_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_front_optic_optic_1442_hubspot_talk_to_sales_modal_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_front_prod_281_project_list_search_19072023_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_optic_1025_zendesk_widget_integration": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_optic_161_project_settings_for_low_agreement_threshold_score_short": {
                  "version": 5,
                  "variation": 1
              },
              "fflag_feat_optic_2123_audio_spectrograms": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_optic_2125_timeseries_sync": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_optic_378_limit_projects_per_page_to_ten_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feat_optic_650_target_storage_task_format_long": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_feat_optic_67_drag_and_drop_charts": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feature_all_optic_1421_cold_start_v2": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_feature_all_optic_1541_performance_score_on_latest_review_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_all_leap_877_annotator_membership_api_03042024_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_fix_all_lsdv_4711_cors_errors_accessing_task_data_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_all_lsdv_4813_async_export_conversion_22032023_short": {
                  "version": 5,
                  "variation": 1
              },
              "fflag_fix_all_lsdv_4896_dm_actions_to_reviewers_20230403_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_fix_all_lsdv_4971_async_reimport_09052023_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_all_optic_18_dashboard_label_distribution_chart_async_22082023_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_fix_all_optic_79_task_count_is_wrong_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_fix_back_dev_3668_review_stream_optimizaion_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_back_dev_4174_overlap_issue_experiments_10012023_short": {
                  "version": 5,
                  "variation": 1
              },
              "fflag_fix_back_dev_4185_next_task_additional_logging_long": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_back_leap_1818_set_convert_background_failure_logging_02062025_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_back_leap_612_explore_review_09042024_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_back_lsdv_4523_show_overlap_first_order_27022023_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_back_lsdv_4604_excess_sql_queries_in_api_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_fix_back_lsdv_4929_limit_exports_10042023_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_back_lsdv_5425_1_enable_permissions_restrictions_for_annotators_long": {
                  "version": 6,
                  "variation": 1
              },
              "fflag_fix_back_optic_1380_dashboard_task_chart_grouped_by_completed_at_reviewed_at_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_back_optic_1407_optimize_tasks_api_pagination_counts": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_fix_font_lsdv_3009_draft_saving_stuck_130223_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_fix_front_dev_1284_auto_detect_undo_281022_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_front_dev_2918_labeling_filtered_paragraphs_250822_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_front_dev_3377_image_regions_shift_on_resize_280922_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_front_dev_3391_interactive_view_all": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_fix_front_dev_3793_relative_coords_short": {
                  "version": 6,
                  "variation": 0
              },
              "fflag_fix_front_leap_218_improve_performance_of_taxonomy_search_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_fix_front_leap_32_zoom_perf_190923_short": {
                  "version": 7,
                  "variation": 0
              },
              "fflag_fix_front_leap_443_select_annotation_once": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_fix_front_lsdv_4600_lead_time_27072023_short": {
                  "version": 4,
                  "variation": 1
              },
              "fflag_fix_front_lsdv_4620_memory_leaks_100723_short": {
                  "version": 7,
                  "variation": 0
              },
              "fflag_fix_front_lsdv_4930_selection_tool_fixes_240423_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_front_lsdv_4998_missed_dynamic_children_030523_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_front_optic_1418_cache_members_manager_apis_short": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_fix_front_optic_1608_improve_video_frame_seek_precision_short": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_fix_leap_2052_detect_empty_filters_at_next_task_endpoint_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_leap_246_multi_object_hotkeys_160124_short": {
                  "version": 3,
                  "variation": 0
              },
              "fflag_fix_leap_466_text_sanitization": {
                  "version": 5,
                  "variation": 0
              },
              "fflag_fix_optic_1259_lse_projects_read_apis_use_replica_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_optic_214_extra_blank_dashboard_charts_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_fix_optic_391_tasks_outside_low_agreement_project_counts_short": {
                  "version": 2,
                  "variation": 1
              },
              "fflag_front_dia_1150_ddisco_sneak_preview": {
                  "version": 3,
                  "variation": 1
              },
              "fflag_optic_all_optic_1938_storage_proxy": {
                  "version": 8,
                  "variation": 0
              },
              "fix_backend_dev_3134_exclude_deactivated_users": {
                  "version": 4,
                  "variation": 1
              }
          },
          "$valid": true
      },
      feature_flags_default_value: true,
      server_id: "c61ef1fd-135f-48e5-a519-37e58efabfb9",
      collect_analytics: true,

      flags: {
          allow_organization_webhooks: false,
          storage_persistence: true,
      },

  }, {});
}

const SENTRY_DSN = window.APP_SETTINGS.sentry_dsn;
const SENTRY_ENV = window.APP_SETTINGS.sentry_environment ?? process.env.NODE_ENV;
const SENTRY_RATE = window.APP_SETTINGS.sentry_rate ? Number.parseFloat(window.APP_SETTINGS.sentry_rate) : 0.25;
const SENTRY_ENABLED = window.APP_SETTINGS.debug === false && isDefined(SENTRY_DSN);

export const initSentry = (history: RouterHistory) => {
  if (SENTRY_ENABLED) {
    setTags();
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        ReactSentry.reactRouterV5BrowserTracingIntegration({ history }),
      ],
      environment: SENTRY_ENV,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: SENTRY_RATE,
      release: getVersion(),
    });
  }
};

export const captureMessage: typeof Sentry.captureMessage = (message, type) => {
  if (!SENTRY_ENABLED) {
    if (typeof type === "string" && type in console) {
      (console as any)[type](message);
    } else {
      console.log(message);
    }
    return "";
  }
  return Sentry.captureMessage(message, type);
};

export const captureException: typeof Sentry.captureException = (exception, captureContext) => {
  if (!SENTRY_ENABLED) {
    console.error(exception, captureContext);
    return "";
  }
  return Sentry.captureException(exception, captureContext);
};

const setTags = () => {
  const tags: Record<string, any> = {};

  if (APP_SETTINGS.user.email) {
    Sentry.setUser({
      email: APP_SETTINGS.user.email,
      username: APP_SETTINGS.user.username,
    });
  }

  if (APP_SETTINGS.version) {
    Object.entries(APP_SETTINGS.version).forEach(([packageName, data]: [string, any]) => {
      const { version, commit } = data ?? {};

      if (version) {
        tags[`version-${packageName}`] = version;
      }
      if (commit) {
        tags[`commit-${packageName}`] = commit;
      }
    });
  }

  Sentry.setTags(tags);
};

const getVersion = () => {
  const version = APP_SETTINGS.version?.["label-studio-os-package"]?.version;

  return version ? version : process.env.RELEASE_NAME;
};

export const SentryRoute = ReactSentry.withSentryRouting(Route);
